//#region import
import React, { useEffect, useState, useContext } from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import { FilterYearContext } from './Dashboard';
import { ParseHtml } from 'utilities/utilities';
import moment from 'moment';
//#endregion

const FilterYear = () => {
    const { setnYearFilter } = useContext(FilterYearContext);

    const [nRow, setnRow] = useState<any>(0);
    const [arrData, setarrData] = useState<any>([]);
    const [sYear, setsYear] = useState<any>(null);

    useEffect(() => {
        let nYear = parseInt(moment(new Date()).format("YYYY")) + 543;
        setsYear(nYear);
        setnYearFilter(parseInt(moment(new Date()).format("YYYY")));  

        setarrData([
            {
                nValue: 0,
                sLabel: "เปรียบเทียบปี <br/> 2565-2566",
                IsAction: false,
            },
            {
                nValue: 2024,
                sLabel: "ปี 2566",
                IsAction: false,
            },
            {
                nValue: 2023,
                sLabel: "ปี 2565",
                IsAction: true,
            }
        ]);
        setnRow(3);
    }, []);

    const handleChangeFilterYear = (nValue) =>
    {
        let arrDataAll = arrData;
        let ObjDataAction = arrDataAll.find((f) => f.nValue !== nValue && f.IsAction === true);
        if(ObjDataAction) ObjDataAction.IsAction = false;   

        let ObjData = arrDataAll.find((f) => f.nValue === nValue);
        if(ObjData){
            ObjData.IsAction = true; 
            setnYearFilter(nValue);  
        }
        setarrData([...arrDataAll]);
    };

    return (        
        <div className="div-MenuListFilter">
            <Grid item xs={12} md={12} container spacing={1}>
                <Grid item xs={12} md={12} style={{ margin: '8%'}}>
                    <Typography variant="h6" display="block">{"รายจ่ายกองทุนจัดการซากดึกดำบรรพ์ ปีบัญชี " + sYear}</Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    {arrData.map((item, index) => {
                        let isDivider = (nRow === (index + 1)) ? true : false;
                        return (
                            <Grid item xs={12} md={12} key={"cFilterYear_" + item.nValue}>
                                <Grid item xs={12} md={12}>
                                    <Divider />
                                </Grid>  
                                <Grid item xs={12} md={12} className={item.IsAction ? "div-FilterYearAction" : "div-FilterYear"}>
                                    <div onClick={()=> { handleChangeFilterYear(item.nValue); }}>
                                        <Typography variant="subtitle2">{ParseHtml(item.sLabel)}</Typography>
                                    </div>
                                </Grid>
                                {isDivider &&
                                    <Grid item xs={12} md={12}>
                                        <Divider/>
                                    </Grid>                                      
                                }
                            </Grid>
                        )
                    })}  
                    <br/>
                    <br/>                    
                </Grid>              
            </Grid>
        </div >
    )
}
export default FilterYear;
